import { render, staticRenderFns } from "./modelView.vue?vue&type=template&id=c23125d2&scoped=true"
import script from "./modelView.vue?vue&type=script&lang=js"
export * from "./modelView.vue?vue&type=script&lang=js"
import style0 from "./modelView.vue?vue&type=style&index=0&id=c23125d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23125d2",
  null
  
)

export default component.exports